import { FlowName } from '@fiverr-private/listing_types';

export type ProfessionRelatedFlowName = Extract<FlowName, 'roleSearchFlow' | 'gigProfessionSearchFlow'>;
export const isProfessionRelatedFlowName = (value: FlowName): value is ProfessionRelatedFlowName =>
    value === 'roleSearchFlow' || value === 'gigProfessionSearchFlow';
